import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

export interface Announcement {
	title: string;
	details: string;
	type: string;
	createdAt: string;
}

const STORAGE_KEY = 'announcement';

export function useAnnouncements() {
	const [announcements, setAnnouncements] = useState<Announcement[]>([]);
	const [hasUnread, setHasUnread] = useState(false);

	useEffect(() => {
		const fetchAnnouncements = async () => {
			try {
				const res = await axios.get('/api/announcements');
				const { announcements: fetched } = res.data;

				setAnnouncements(fetched);

				if (!fetched?.length) return;

				const raw = localStorage.getItem(STORAGE_KEY);
				let stored: Announcement | null = null;

				if (raw) {
					try {
						stored = JSON.parse(raw);
					} catch {
						localStorage.removeItem(STORAGE_KEY);
					}
				}

				if (
					!stored ||
					stored.createdAt < fetched[0].createdAt
				) {
					setHasUnread(true);
				}
			} catch (err) {
				console.log(err);
			}
		};

		fetchAnnouncements();
	}, []);

	const markAsRead = useCallback(() => {
		if (announcements.length > 0) {
			localStorage.setItem(
				STORAGE_KEY,
				JSON.stringify(announcements[0]),
			);
		}
		setHasUnread(false);
	}, [announcements]);

	return { announcements, hasUnread, markAsRead };
}
